import config from 'config';
import API from 'services/AUTH_API';
import Storage from 'services/Storage';

export default function runAs(inn) {
  const token = Storage.getItem(config.tokenItemName);
  let data = new FormData();
  data.append('username', inn);
  data.append('token', token);
  data.append('client_id', config.clientId);

  return API.request({
    method: 'POST',
    url: `/oauth/run-as`,
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
